import TitleH1 from "../Titles/title-h1";
import React, {useEffect, useState} from "react";
import api from "../../services/api";
import {generatePath, Link, useLocation} from "react-router-dom";
import Picture from "../books/BookPagePresentation/Picture";
import ROUTES from "../../route";
import BookTitle from "../books/BookPagePresentation/BookTitle";
import PublicationDate from "../books/BookPagePresentation/PublicationDate";

const Author = () => {
    const [books, setBooks] = useState();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const state = location.state;
    const author = state?.author;

    useEffect(() => {
        api.get(`/getBookFromAuthor/${author.id}`).then(response => {
            setBooks(response.data.books);
            console.log(response.data);
        })
            .catch(error => {
                console.error('Failed to fetch the book', error);
            })
            .finally(() => {
                setLoading(false);
            });

    }, []);


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="p-4">  {/* Added padding around the entire grid */}
            <TitleH1>{author.name}</TitleH1>
            <div className="grid grid-cols-3 gap-4">
                {books.map((book, index) => (
                    <>
                        <Link to={generatePath(ROUTES.BOOK_SHOW, {id: book.id})} className="flex items-center space-x-4">
                            <Picture
                                key={index}
                                book={book}
                                className="w-16 h-16 rounded-md shadow-lg object-contain"
                            />
                            <div>
                                <BookTitle title={book.title}/>
                                <PublicationDate date={book.date_of_publication}/>
                            </div>

                        </Link>
                    </>
                ))}
            </div>
        </div>
    )
}

export default Author;